import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { supabase } from "@/integrations/supabase/client";

type Status = "idle" | "loading" | "success" | "error";

export function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [errorMsg, setErrorMsg] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    const { error } = await supabase.functions.invoke("waitlist", {
      body: { email: email.trim().toLowerCase() },
    });

    if (error) {
      setStatus("error");
      setErrorMsg("Something went wrong. Please try again.");
    } else {
      setStatus("success");
    }
  }

  if (status === "success") {
    return (
      <div className="space-y-1 text-center">
        <p className="font-serif text-xl text-primary">You're on the list!</p>
        <p className="text-sm text-muted-foreground">Check your inbox for a confirmation.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="mx-auto w-full max-w-sm space-y-3">
      <p className="text-center font-serif text-xl">Get early access</p>
      <div className="flex gap-2">
        <Input
          type="email"
          placeholder="you@example.com"
          aria-label="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={status === "loading"}
          className="flex-1"
        />
        <Button
          type="submit"
          disabled={status === "loading"}
          className="shrink-0 gap-1.5"
        >
          {status === "loading" ? "Joining…" : (
            <>Join <ArrowRight className="h-3.5 w-3.5" /></>
          )}
        </Button>
      </div>
      {status === "error" && (
        <p className="text-center text-sm text-destructive" role="alert">
          {errorMsg}
        </p>
      )}
    </form>
  );
}
